import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-30067865"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar d-flex d-sm-none w-100 align-center justify-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_3 = { class: "mr-2" }
const _hoisted_4 = {
  key: 1,
  class: ""
}
const _hoisted_5 = {
  key: 2,
  class: "online-status"
}

import { computed } from "vue";
import { useStore } from "vuex";
import OnlineStatus from "@/components/OnlineStatus.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'MobileAppbar',
  setup(__props) {

const store = useStore();
const shiftInfoLoading = computed(() => store.getters["shiftService/selectShiftInfoLoading"]);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$route.meta.showBackButton)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "goback",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
        }, [
          _createVNode(_component_v_icon, { class: "mr-2 arrow" }, {
            default: _withCtx(() => [
              _createTextVNode("mdi-chevron-left")
            ]),
            _: 1
          }),
          _hoisted_2
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.$route.meta.pageName), 1),
    (_ctx.$route.meta.showId)
      ? (_openBlock(), _createElementBlock("h4", _hoisted_4, "№" + _toDisplayString(_ctx.$route.params.id), 1))
      : _createCommentVNode("", true),
    (shiftInfoLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            color: "#028179"
          })
        ]))
      : (_openBlock(), _createBlock(OnlineStatus, { key: 3 }))
  ]))
}
}

})